module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-solid-4a0c51c8b08d47fbcd8344be31f4321d.svg";